export const enum WorkerMessageType {
    Ping = 'Ping',
    CheckJwt = 'CheckJwt',
}
